import React, { useMemo } from "react";
import { SocketContextProvider } from "./Socket";
import { ChatAudio } from "../audio";
import ArbokApi from "../api/requests/arbok-api";
import AppConfig from "../app-config";
import ArachnaApi from "../api/requests/arachna-api";
import { DEFAULT_SUPPORTED_LANGUAGES, LanguageContextProvider } from "./LanguageProvider";
import '../prototypes';
const MainContext = React.createContext({});
export const MainContextProvider = (props) => {
    useMemo(() => {
        const data = Object.assign({}, props);
        delete data.children;
        AppConfig.setConfig(data);
        ArbokApi.setConfig({
            baseURL: data.urls.arbok
        });
        ArachnaApi.setConfig({
            baseURL: data.urls.arachnaApi
        });
        if (props.urls.notify)
            ChatAudio.setConfig({
                src: props.urls.notify
            });
    }, [props]);
    return (React.createElement(MainContext.Provider, { value: {} },
        React.createElement(LanguageContextProvider, { languageKey: AppConfig.getConfig().lang, supported_languages: DEFAULT_SUPPORTED_LANGUAGES },
            React.createElement(SocketContextProvider, null, props.children))));
};
export default MainContext;
